import React from "react";
import { RollbackOutlined } from "@ant-design/icons";
import { Col, Row, Button } from "antd";
import { Link } from "react-router-dom";

import Bg404 from "../../../assets/images/banner-404.jpg";

const PageNotFound = () => {
  return (
    <Row className="mobile__bg404" style={{ backgroundImage: `url(${Bg404})`, minHeight: "calc(100vh - 85px)" }}>
      <Col span={24} className="d-flex flex-column jc-center ai-center">
        <p className="f-26 white text-center">
          <b>Desculpe, página não encontrada!</b>
          <br />
          Caso precise de assistência, entre em contato conosco.
          <br /> Agradecemos a sua compreensão!
        </p>
        <Link to="/">
          <Button className="mt-30" type="primary" size="large">
            <RollbackOutlined />
            Homepage
          </Button>
        </Link>
      </Col>
    </Row>
  );
};

export default PageNotFound;
